"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchTranslationsWithNamespaces = fetchTranslationsWithNamespaces;
var _fetching = require("@ori/fetching");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _mergeTranslations = require("./mergeTranslations");
function fetchTranslationsWithNamespaces(_) {
    return _fetchTranslationsWithNamespaces.apply(this, arguments);
}
function _fetchTranslationsWithNamespaces() {
    _fetchTranslationsWithNamespaces = /**
 * Fetches translations with namespaces from the specified API endpoint for different packages.
 *
 * @typeParam T Type of the translations object.
 * @param options Fetch options.
 * @returns  Promise resolving to the fetched translations.
 */ _async_to_generator(function(param) {
        var _param_language, language, defaultTranslationsWithNamespaces, clientFetchConfiguration, onError, tenant, _clientFetchConfiguration_baseUrl, baseUrl, translationsWithNamespaces, staticApiClient, getPackageTranslations, getTranslations, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param_language = param.language, language = _param_language === void 0 ? '' : _param_language, defaultTranslationsWithNamespaces = param.defaultTranslationsWithNamespaces, clientFetchConfiguration = param.clientFetchConfiguration, onError = param.onError;
                    tenant = clientFetchConfiguration.tenant, _clientFetchConfiguration_baseUrl = clientFetchConfiguration.baseUrl, baseUrl = _clientFetchConfiguration_baseUrl === void 0 ? window.location.origin : _clientFetchConfiguration_baseUrl;
                    translationsWithNamespaces = JSON.parse(JSON.stringify(defaultTranslationsWithNamespaces)); // Creates deep copy of default translations
                    staticApiClient = new _staticApiClientReact.ApiClient({
                        baseUrl: baseUrl,
                        language: language,
                        tenant: tenant,
                        camelcaseKeysOptions: {
                            stopPaths: [
                                'Localizations'
                            ]
                        }
                    });
                    getPackageTranslations = /*#__PURE__*/ function() {
                        var _ref = _async_to_generator(function(packageId) {
                            var missingTenantError, response;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!tenant) {
                                            missingTenantError = new Error('Missing tenant for getTenantLocalization');
                                            onError(missingTenantError);
                                            throw missingTenantError;
                                        }
                                        return [
                                            4,
                                            (0, _staticApiClientReact.getTenantLocalization)(staticApiClient, tenant, packageId, {
                                                lang: language
                                            })
                                        ];
                                    case 1:
                                        response = _state.sent();
                                        return [
                                            2,
                                            (0, _fetching.handleResponse)(response, {
                                                onSuccess: function(param) {
                                                    var data = param.data;
                                                    return data.localizations;
                                                },
                                                onError: function(result) {
                                                    onError(result);
                                                    return {};
                                                }
                                            })
                                        ];
                                }
                            });
                        });
                        return function getPackageTranslations(packageId) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    getTranslations = /*#__PURE__*/ function() {
                        var _ref = _async_to_generator(function() {
                            return _ts_generator(this, function(_state) {
                                return [
                                    2,
                                    Promise.all(Object.keys(defaultTranslationsWithNamespaces).map(/*#__PURE__*/ function() {
                                        var _ref = _async_to_generator(function(packageId) {
                                            var packageTranslations;
                                            return _ts_generator(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            getPackageTranslations(packageId)
                                                        ];
                                                    case 1:
                                                        packageTranslations = _state.sent();
                                                        translationsWithNamespaces = (0, _mergeTranslations.mergeTranslations)(translationsWithNamespaces, packageTranslations, packageId);
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(packageId) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            });
                        });
                        return function getTranslations() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        getTranslations()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    onError(error);
                    return [
                        2,
                        {
                            error: error,
                            translationsWithNamespaces: translationsWithNamespaces
                        }
                    ]; // Returns default translations when api fails
                case 4:
                    return [
                        2,
                        {
                            translationsWithNamespaces: translationsWithNamespaces
                        }
                    ];
            }
        });
    } //# sourceMappingURL=fetchTranslationsWithNamespaces.js.map
    );
    return _fetchTranslationsWithNamespaces.apply(this, arguments);
}
